module.exports = __webpack_public_path__ + "static/media/Grey.f8809145.png";